// extracted by mini-css-extract-plugin
module.exports = {"base":"ExperimentTrials_base__2A-gv","hasRestarts":"ExperimentTrials_hasRestarts__25aNH"};